import { Info } from "@shared/v2/Icomoon";
import Tooltip from "@shared/v2/Tooltip";

const TextAndPhoneTooltip = () => (
  <span className="tw-pl-[4px]">
    <Tooltip
      content={
        <div className="tw-w-[180px] tw-text-left">
          Contacts with at least one phone number matching your selected filter will appear as results
        </div>
      }
      trigger={<Info size="m" className="tw-text-gray-75" />}
      placement="top"
    />
  </span>
);

export default TextAndPhoneTooltip;
